import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { POSITIVE_COLOR, NEGATIVE_COLOR } from '../../utils/constants';

const useStyles = makeStyles({
    negative: {
        color: NEGATIVE_COLOR,
    },
    positive: {
        color: POSITIVE_COLOR
    },
    percentage: {
        fontSize: 16,
        fontWeight: 700
    }
});

const Percent = ({ percentage, theme }) => {
    const classes = useStyles();

    return (
        <Typography
            className={clsx(
                percentage < 0 ? classes.negative: classes.positive,
                classes.percentage,
                !theme && classes.percentageLight
            )}
        >
            { percentage >= 0 ? `+${Math.round(percentage)}`: Math.round(percentage)}%
        </Typography>                
    )
}

export default Percent;
